/**
 * /frontend/src/features/analytics/components/staffing/ForecastVsActualChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import TrendLineChart from '../charts/TrendLineChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Forecast vs actual line chart.
 * @param {{data:Array<any>}} props
 * @returns {JSX.Element}
 */
const ForecastVsActualChart = ({ data }) => {
  const lines = useMemo(() => ([
    { key: 'predictedJoins', label: 'Forecast', color: CHART_COLORS.accent },
    { key: 'actualJoins', label: 'Actual', color: CHART_COLORS.warning }
  ]), []);

  return (
    <ChartContainer title="Forecast vs Actual" subtitle="Shows actuals once available">
      <TrendLineChart data={data} xKey="label" lines={lines} />
    </ChartContainer>
  );
};

export default ForecastVsActualChart;

